import { Card, Typography } from 'antd';
import { ToolOutlined } from '@ant-design/icons';

interface PagePlaceholderProps {
  title: string;
  description?: string;
}

/**
 * 占位页面组件
 *
 * 阶段 7 用于所有尚未实现业务逻辑的路由，
 * 阶段 8 替换为真实页面。
 */
export default function PagePlaceholder({ title, description }: PagePlaceholderProps) {
  return (
    <Card>
      <div style={{ textAlign: 'center', padding: '64px 0' }}>
        <ToolOutlined style={{ fontSize: 48, color: '#1677ff', marginBottom: 16 }} />
        <Typography.Title level={4} style={{ marginBottom: 8 }}>
          {title}
        </Typography.Title>
        <Typography.Text type="secondary">
          {description ?? '该页面正在开发中，敬请期待'}
        </Typography.Text>
      </div>
    </Card>
  );
}
